import { replayMap } from '@/api';
import { post } from '@/common/request';
import { PropertyValue } from './place';

interface SearchParams {
  priority?: {
    maxValue: number;
    minValue: number
  };
  tenantPlaceName?: string;
  employeeIdList?: number[];
  typeList?: number[];
};

export interface ReplayInfo {
  tenantPlaceId?:	number;
  tenantPlaceName?:	string;
  priority?: number;
  typeNameList?: string[]
  employeeList?:	any[]
  createTime?: string
  createUser?: string
  status?: number
  statusType?: string;
  statusName?: string;
  rejectReason?:	string
}

interface Response {
  pageNum?: number;
  pageSize?: number;
  objectList?: ReplayInfo[];
}

interface ReplayDetail {
  supplierId?: number;
  person?: string
  visitDate?:	string;
  visitDateString?:	string;
  visitType?:	number;
  remark?: string;
  tntReviewPlacePropertyList?: ReplayProper[];
  tntReviewSpotPropertyList?: ReplayProper[];
  tenantPlaceId?:	number;
}

interface ReplayProper {
  reviewRecordId?: number;
  tenantPlaceId?:	number;
  propertyId?: number;
  propertyValue?:	string;
}

class Replay {
  getList(page: number, size: number, searchParams?: SearchParams): Promise<Response> {
    return post(replayMap.get('list'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  batchEmployee(reviewTaskId, employeeIdList): Promise<boolean> {
    return post(replayMap.get('batch'), { reviewTaskId, employeeIdList }, { proxyApi: '/resserv', needHint: true });
  }

  detail(id: number): Promise<{snapshot: ReplayDetail}> {
    return post(replayMap.get('detail'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  snapshotDetail(id: number): Promise<{snapshot: ReplayDetail}> {
    return post(replayMap.get('snapshotDetail'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  commit(reviewTaskId: number, info: ReplayProper, tntReviewPlacePropertyList?: ReplayProper[], tntReviewSpotPropertyList?: ReplayProper): Promise<boolean> {
    return post(replayMap.get('commit'), { reviewTaskId, tntReviewPlacePropertyList, tntReviewSpotPropertyList, ...info }, { proxyApi: '/resserv', needHint: true });
  }

  save(reviewTaskId: number, snapShot: any): Promise<boolean> {
    return post(replayMap.get('save'), { reviewTaskId, snapShot: JSON.stringify(snapShot) }, { proxyApi: '/resserv', needHint: true });
  }

  getPlacePropertys(reviewTaskId: number): Promise<{tenantPlaceName?: string, tenantPlaceId?: string, propertyValueVOList?: PropertyValue }> {
    return post(replayMap.get('placeProperty'), { reviewTaskId }, { proxyApi: '/resserv', needHint: true });
  }

  getSpotPropertys(reviewTaskId: number, tenantSpotId: number): Promise<PropertyValue[]> {
    return post(replayMap.get('spotProperty'), { reviewTaskId, tenantSpotId }, { proxyApi: '/resserv', needHint: true });
  }
}

export default new Replay();
